import {
  GET_INVOICES_REQUEST,
  GET_INVOICES_SUCCESS,
  GET_INVOICES_FAILURE,
  CREATE_INVOICE_REQUEST,
  CREATE_INVOICE_SUCCESS,
  CREATE_INVOICE_FAILURE,
  UPDATE_INVOICE_REQUEST,
  UPDATE_INVOICE_SUCCESS,
  UPDATE_INVOICE_FAILURE,
  GET_INVOICE_REQUEST,
  GET_INVOICE_SUCCESS,
  GET_INVOICE_FAILURE,
  GENERATE_PDF_REQUEST,
  GENERATE_PDF_SUCCESS,
  GENERATE_PDF_FAILURE,
  GET_SALES_SUMMARY_REQUEST,
  GET_SALES_SUMMARY_SUCCESS,
  GET_SALES_SUMMARY_FAILURE,
  CONVERT_ORDER_TO_INVOICE_REQUEST,
  CONVERT_ORDER_TO_INVOICE_SUCCESS,
  CONVERT_ORDER_TO_INVOICE_FAILURE,
  GET_INVOICE_PAYMENTS_REQUEST,
  GET_INVOICE_PAYMENTS_SUCCESS,
  GET_INVOICE_PAYMENTS_FAILURE,
  CANCEL_INVOICE_REQUEST,
  CANCEL_INVOICE_SUCCESS,
  CANCEL_INVOICE_FAILURE,
} from '../types';
import api from '../../services/api';

// Get all invoices
export const getInvoices = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_INVOICES_REQUEST });

    const response = await api.get('/billing/invoices', { params });
    const data = response.data.data;

    dispatch({
      type: GET_INVOICES_SUCCESS,
      payload: data,
    });

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get invoices';
    dispatch({
      type: GET_INVOICES_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Get invoice by ID
export const getInvoice = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_INVOICE_REQUEST });

    const response = await api.get(`/billing/invoices/${id}`);
    const invoice = response.data.data;

    dispatch({
      type: GET_INVOICE_SUCCESS,
      payload: invoice,
    });

    return { success: true, data: invoice };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get invoice';
    dispatch({
      type: GET_INVOICE_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Create invoice
export const createInvoice = (invoiceData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_INVOICE_REQUEST });

    const response = await api.post('/billing/invoices', invoiceData);
    const invoice = response.data.data;

    dispatch({
      type: CREATE_INVOICE_SUCCESS,
      payload: invoice,
    });

    return { success: true, data: invoice };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create invoice';
    dispatch({
      type: CREATE_INVOICE_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Update invoice
export const updateInvoice = (id, invoiceData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_INVOICE_REQUEST });

    const response = await api.put(`/billing/invoices/${id}`, invoiceData);
    const invoice = response.data.data;

    dispatch({
      type: UPDATE_INVOICE_SUCCESS,
      payload: invoice,
    });

    return { success: true, data: invoice };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update invoice';
    dispatch({
      type: UPDATE_INVOICE_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Generate invoice PDF
export const generateInvoicePDF = (id) => async (dispatch) => {
  try {
    dispatch({ type: GENERATE_PDF_REQUEST });

    const response = await api.get(`/billing/invoices/${id}/pdf`, {
      responseType: 'blob'
    });

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `invoice-${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    dispatch({
      type: GENERATE_PDF_SUCCESS,
    });

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to generate PDF';
    dispatch({
      type: GENERATE_PDF_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Generate Bhavani Jewellery style invoice PDF
export const generateBhavaniJewelleryPDF = (id) => async (dispatch) => {
  try {
    dispatch({ type: GENERATE_PDF_REQUEST });

    const response = await api.get(`/billing/invoices/${id}/bhavani-pdf`, {
      responseType: 'blob'
    });

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `bhavani-invoice-${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    dispatch({
      type: GENERATE_PDF_SUCCESS,
    });

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to generate Bhavani Jewellery PDF';
    dispatch({
      type: GENERATE_PDF_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Generate Modern Invoice PDF (Client Requested Format)
export const generateModernInvoicePDF = (id) => async (dispatch) => {
  try {
    dispatch({ type: GENERATE_PDF_REQUEST });

    const response = await api.get(`/billing/invoices/${id}/modern-pdf`, {
      responseType: 'blob'
    });

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `modern-invoice-${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    dispatch({
      type: GENERATE_PDF_SUCCESS,
    });

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to generate Modern Invoice PDF';
    dispatch({
      type: GENERATE_PDF_FAILURE,
      payload: message
    });
    return { success: false, message };
  }
};

// Get sales summary
export const getSalesSummary = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_SALES_SUMMARY_REQUEST });

    const response = await api.get('/billing/sales-summary', { params });
    const summary = response.data.data;

    dispatch({
      type: GET_SALES_SUMMARY_SUCCESS,
      payload: summary,
    });

    return { success: true, data: summary };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get sales summary';
    dispatch({
      type: GET_SALES_SUMMARY_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Convert order to invoice
export const convertOrderToInvoice = (orderId, additionalData = {}) => async (dispatch) => {
  try {
    dispatch({ type: CONVERT_ORDER_TO_INVOICE_REQUEST });

    const response = await api.post(`/billing/orders/${orderId}/convert-to-invoice`, {
      additionalData
    });

    dispatch({
      type: CONVERT_ORDER_TO_INVOICE_SUCCESS,
      payload: response.data.data,
    });

    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to convert order to invoice';
    dispatch({
      type: CONVERT_ORDER_TO_INVOICE_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Cancel Invoice
export const cancelInvoice = (invoiceId, cancelData) => async (dispatch) => {
  try {
    dispatch({ type: CANCEL_INVOICE_REQUEST });
    
    const response = await api.put(`/billing/invoices/${invoiceId}/cancel`, cancelData);
    
    dispatch({
      type: CANCEL_INVOICE_SUCCESS,
      payload: response.data.data,
    });
    
    return { 
      success: true, 
      data: response.data.data,
      pendingAmount: response.data.pendingAmount 
    };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to cancel invoice';
    dispatch({
      type: CANCEL_INVOICE_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Receive Payment Against Invoice
export const receivePayment = (invoiceId, paymentData) => async (dispatch) => {
  try {
    dispatch({ type: 'RECEIVE_PAYMENT_REQUEST' });
    
    const response = await api.post(`/billing/invoices/${invoiceId}/receive-payment`, paymentData);
    
    dispatch({
      type: 'RECEIVE_PAYMENT_SUCCESS',
      payload: response.data.data,
    });
    
    return { 
      success: true, 
      data: response.data.data,
      payment: response.data.payment,
      newPaymentStatus: response.data.newPaymentStatus,
      totalPaid: response.data.totalPaid,
      pendingAmount: response.data.pendingAmount
    };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to receive payment';
    dispatch({
      type: 'RECEIVE_PAYMENT_FAILURE',
      payload: message,
    });
    return { success: false, message };
  }
};

// Get invoice payments by payment mode
export const getInvoicePayments = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_INVOICE_PAYMENTS_REQUEST });
    
    const queryParams = new URLSearchParams();
    if (filters.paymentModeId) queryParams.append('paymentModeId', filters.paymentModeId);
    if (filters.startDate) queryParams.append('startDate', filters.startDate);
    if (filters.endDate) queryParams.append('endDate', filters.endDate);
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.page) queryParams.append('page', filters.page);
    if (filters.limit) queryParams.append('limit', filters.limit);
    
    const response = await api.get(`/billing/payments?${queryParams.toString()}`);
    
    dispatch({
      type: GET_INVOICE_PAYMENTS_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch invoice payments';
    dispatch({
      type: GET_INVOICE_PAYMENTS_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};
